import { hasDOM } from '../utilities/dom'

import { RESELLER } from './brand'

function getHost() {
  let host = 'dev.rebel.com'

  if (hasDOM) {
    const { hostname } = window.location

    if (__PROD__) {
      // Handle CI
      host =
        hostname === 'localhost' ? 'www.rebel.com' : window.location.hostname
    } else if (__DEV__) {
      host = `dev.${RESELLER}`
    } else if (__LOCAL__) {
      host = `local.${RESELLER}`
    }
  }

  return host
}

const host = getHost()

export { host }
